import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'

import { CommonModule, NgClass, NgIf } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CaseListComponent } from '../../../abacus/components/case-list.component'
import { CaseInputComponent } from '../../../abacus/elements/inputs/case-input/case-input.component'
import { MetaComponent } from '../../../abacus/elements/partials/meta/meta.component'
import { PaginationComponent } from '../../../abacus/elements/partials/pagination/pagination.component'
import { TableComponent } from '../../../abacus/elements/partials/table/table.component'
import { InputType } from '../../../abacus/enums/input-type.enum'
import { Filter } from '../../../abacus/interfaces/filter.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { Yield } from '../../../abacus/interfaces/yield.interface'
import { AuthService } from '../../../abacus/services/auth.service'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FilterService } from '../../../abacus/services/filter.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { EurosPipe, HasPermissionDirective } from '../../../abacus/standalone-exports'
import { caseListTemplate } from '../../../abacus/templates/case-list.template'
import { Status } from '../../../common/enums/status.enum'
import { metricDefinition } from '../metric.definition'
import { metricYields } from '../metric.yields'

@Component({
  template: caseListTemplate,
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    NgClass,
    ReactiveFormsModule,
    FormsModule,
    TableComponent,
    HasPermissionDirective,
    CaseInputComponent,
    RouterModule,
    PaginationComponent,
    MetaComponent,
    EurosPipe
  ]
})
export class MetricListComponent extends CaseListComponent implements OnInit {
  definition: ResourceDefinition = metricDefinition
  yields: Yield[] = metricYields

  filters: Filter[] = [
    {
      label: 'Search a metric',
      properties: {
        metricIds: 'metricIds'
      },
      inputType: InputType.MultiSearch,
      searchResources: [metricDefinition],
      className: 'is-6'
    },
    {
      label: 'Status',
      property: 'status',
      placeholder: 'All status',
      inputType: InputType.Select,
      selectOptions: [
        {
          label: 'Published',
          value: Status.Published
        },
        {
          label: 'Pending',
          value: Status.Pending
        },
        {
          label: 'Rejected',
          value: Status.Rejected
        }
      ]
    }
  ]

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    authService: AuthService,
    filterService: FilterService
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
